import { TableRow } from './TableRow';
export const TableHeadRow = TableRow;
